/** Shared policy for opaque HTML frames; only interactive views receive a script nonce. */
export function htmlFrameCsp({ nonce, frames = false, allowRemoteImages = false }: {
  nonce?: string;
  frames?: boolean;
  allowRemoteImages?: boolean;
} = {}): string {
  return `default-src 'none'; script-src ${nonce ? "'nonce-" + nonce + "'" : "'none'"}; style-src 'unsafe-inline'; connect-src 'none'; img-src data:${allowRemoteImages ? ' https:' : ''}; font-src 'none'; media-src 'none'; object-src 'none'; frame-src ${frames ? 'about:' : "'none'"}; base-uri 'none'; form-action 'none'`;
}
